const PAGE_EXPRESSION = /\/page\/(\d+)/
const FIRST_PAGE = 1
const DECIMAL = 10

/**
 * Restores the pagination offset from the current friendly url.
 *
 * Url is the only source of truth after a history navigation,
 * while `initial` holds the offset of the initially rendered page.
 */
export function paginationFromUrl({ limit } = {}) {
  if (!limit) {
    return {}
  }

  const [, page] = window.location.pathname.match(PAGE_EXPRESSION) || []
  const currentPage = parseInt(page, DECIMAL) || FIRST_PAGE

  return { offset: (currentPage - FIRST_PAGE) * limit }
}
